import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionWrapper } from '../SectionWrapper';
import { DocumentsUploader } from './DocumentsUploader';
import clsx from 'clsx';
import { ErrorNotificationComponent } from './ErrorNotificationComponent';

import './Documents.scss';

interface Props {
  fileList: any[];
  setFileList: (fileList: any[]) => void;
  uploadedDocuments?: any[];
  setUploadedDocuments?: (uploadedFiles: any[]) => void;
  isError?: boolean;
  sectionAdditionalClass?: string;
}

export const ApplicationViewBusinessDetailsDocuments: FC<Props> = (props) => {
  const { t } = useTranslation();

  const { fileList, setFileList, uploadedDocuments, setUploadedDocuments, isError, sectionAdditionalClass } = props;

  return (
    <SectionWrapper
      title={t('SELF_ONBOARDING.SECTION_TITLE.DOCUMENT')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass={clsx(sectionAdditionalClass)}
      id="Documents"
    >
      <DocumentsUploader
        fileList={fileList}
        setFileList={setFileList}
        uploadedDocuments={uploadedDocuments}
        setUploadedDocuments={setUploadedDocuments}
        isError={isError}
        isRequired
        showAdditionalInfo
        enableToDelete
      />

      {
        isError && (
          <ErrorNotificationComponent
            title="You have not attached your processing statements"
            text="Processing statements must be attached to every application."
            containerAdditionalClass="mt-5"
          />
        )
      }
    </SectionWrapper>
  );
};
